import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Icon, Modal, notification } from "antd";
import { isSuperUser } from "../../../../../utils/is-superuser";
import CurrencyField from "../../../../../components/CurrencyField";

import "./styles.css";
import api from "../../../../../services/api";
import { format } from "../../../../../utils/MoneyFormater";

export const ValorPago = (props) => {
  const {
    idParcela,
    parcelaId,
    parcela_id,
    initialValue = 0,
    data = {},
    visible,
    onCancel,
    updateFunction,
  } = props;

  const { numero_nf = null, status_conciliado = "NAO CONCILIADO" } = data;
  const parcelaIdentificador = idParcela || parcelaId || parcela_id;

  const [isEditing, setEditing] = useState(false);
  const [isSaving, setSaving] = useState(false);
  const [value, setValue] = useState(initialValue);
  const [inputValue, setInputValue] = useState(initialValue || 0);

  const isControlled = typeof visible === "boolean";
  const editing = isControlled ? visible : isEditing;

  const openEditing = () => {
    if (isControlled) return;
    setEditing(true);
  };

  const closeEditing = () => {
    if (isControlled) {
      onCancel();
    } else {
      setEditing(false);
    }
  };

  const handleSave = () => {
    if (!parcelaIdentificador) {
      notification.error({
        message: "Parcela não encontrada para atualizar o valor pago.",
      });
      return;
    }

    setSaving(true);

    api
      .post(`/contratos/parcela/${parcelaIdentificador}/nf/`, {
        numero_nf: inputValue <= 0 ? null : numero_nf,
        status_conciliado:
          inputValue <= 0 ? "NAO CONCILIADO" : status_conciliado,
        status_pago: inputValue > 0 ? "PAGO" : "NAO PAGO",
        valor_pago: inputValue,
      })
      .then(() => {
        notification.success({
          message: "Valor pago atualizado com sucesso.",
        });
        setValue(inputValue);
        updateFunction();
        closeEditing();
      })
      .catch(() => {
        notification.error({
          message: "Ocorreu um erro ao atualizar o valor pago.",
        });
      })
      .finally(() => {
        setSaving(false);
      });
  };

  useEffect(() => {
    if (editing) {
      setInputValue(value || 0);
    }
  }, [editing, value]);

  useEffect(() => {
    setValue(initialValue);
    setInputValue(initialValue || 0);
  }, [initialValue]);

  const isAdmin = isSuperUser();

  return (
    <div className="valor_pago__container">
      {!isControlled && (
        <div>
          <span>{value === null ? "---" : `R$ ${format(value)}`}</span>
          {isAdmin && (
            <Button type="primary" ghost size="small" onClick={openEditing}>
              <Icon type="edit" />
            </Button>
          )}
        </div>
      )}
      <Modal
        visible={editing}
        title="Valor pago da parcela"
        okText="Salvar"
        cancelText="Cancelar"
        onCancel={closeEditing}
        confirmLoading={isSaving}
        onOk={handleSave}
        cancelButtonProps={{
          disabled: isSaving,
        }}
      >
        <label htmlFor="value">Insira o valor pago:</label>
        <div style={{ marginTop: "5px" }}>
          {editing && (
            <CurrencyField
              id="value"
              name="value"
              fieldValue={inputValue}
              className="ant-input"
              placeholder="R$"
              onChangeEvent={setInputValue}
              autoFocus
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

ValorPago.propTypes = {
  initialValue: PropTypes.number,
  idParcela: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  parcelaId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  parcela_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  data: PropTypes.shape({
    numero_nf: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status_conciliado: PropTypes.string,
  }),
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  updateFunction: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/Contrato/ValorPago/index.jsx